import { render, staticRenderFns } from "./BigWidthCard.vue?vue&type=template&id=44f5e8e6&"
import script from "./BigWidthCard.vue?vue&type=script&lang=js&"
export * from "./BigWidthCard.vue?vue&type=script&lang=js&"
import style0 from "./BigWidthCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports